import { Button, Form, Input, Space, Typography } from 'antd';

import { CustomAlert } from '@app/components/CustomAlert';
import {
  EMAIL_LENGTH_VALIDATION,
  EMAIL_TYPE_VALIDATION,
  ERROR,
  ERROR_REQUIRED_FIELD,
  OFF,
  ONE_TIME_CODE,
} from '@app/constants';

import type { NUserProfile } from '@pages/Users/UserProfile/UserProfile.types';

export const EmailInfo: NUserProfile.EmailInfo = ({
  currentEmail,
  updateEmail,
  setServerError,
  serverError,
}) => {
  const [form] = Form.useForm();

  return (
    <div>
      <Form
        form={form}
        onFinish={updateEmail}
        className="form"
        autoComplete={OFF}
      >
        <Space direction="vertical" size="middle" className="form-space">
          <div className="container">
            <Typography.Text strong data-testid="current-email">
              Текущий email
            </Typography.Text>

            <Form.Item className="mg-0">
              <Typography.Title level={5} data-testid="current-email-value">
                {currentEmail}
              </Typography.Title>
            </Form.Item>
          </div>

          <div className="container">
            <Typography.Text
              strong
              className="label-require"
              data-testid="new-email"
            >
              Новый email
            </Typography.Text>

            <div className="new-email-container">
              <Form.Item
                name="Email"
                className="mg-0"
                rules={[
                  EMAIL_TYPE_VALIDATION,
                  EMAIL_LENGTH_VALIDATION,
                  {
                    required: true,
                    message: (
                      <span data-testid="email-alert">
                        {ERROR_REQUIRED_FIELD}
                      </span>
                    ),
                  },
                ]}
              >
                <Input
                  maxLength={100}
                  autoComplete={ONE_TIME_CODE}
                  size="large"
                  data-testid="email-input"
                />
              </Form.Item>

              <Typography.Text
                type="secondary"
                data-testid="email-confirmation-alert"
              >
                На новый email будет выслано письмо со ссылкой для подтверждения
              </Typography.Text>
            </div>
          </div>

          {!!serverError && (
            <CustomAlert
              errorType={ERROR}
              serverError={serverError}
              setServerError={setServerError}
            />
          )}

          <Button
            type="primary"
            htmlType="submit"
            className="save-button"
            data-testid="save-email"
          >
            Сохранить
          </Button>
        </Space>
      </Form>
    </div>
  );
};
